export const isPasswordLikeField = field => {
  return (
    ['PASSWORD', 'COMPLEX_PASSWORD'].includes(field?.component) ||
    /password/i.test(field?.name ?? '')
  );
};

export const resolveSignInAutoComplete = field => {
  if (isPasswordLikeField(field)) return 'current-password';
  if (field?.name === 'EMAIL') return 'email';
  if (['LOGIN', 'USERNAME'].includes(field?.name)) return 'username';
  if (field?.name === 'PHONE') return 'tel';
  return field?.autocomplete;
};

export const resolveSignUpAutoComplete = field => {
  // intentionally disable browser password suggestions on sign-up for all password-like fields
  if (isPasswordLikeField(field)) return 'off';
  return field?.autocomplete;
};
